import { FC } from "react";
import * as Icon from "../icons";
import { T } from "@tolgee/react";

export const CheckEmailExplainerHeader: FC = () => {
  return (
    <div className="flex items-center gap-2.5 text-base font-medium text-mandarin-900">
      <Icon.Bell className="text-mandarin-600" size={20} />
      <T keyName="check-email-dialog-header-title" />
    </div>
  );
};
